import { OltConfigServiceBase } from '@outerlimitstech/ngx-app-core';

export abstract class BaseConfigService extends OltConfigServiceBase {
  abstract get signalRUrl(): string;
}
